import { isEmbarcacaoMotoresEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoMotor,
  EmbarcacaoMotoresState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const MOTORES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoMotor[]> = {
  select: (ficha) => ficha.motores,
  isEmpty: isEmbarcacaoMotoresEmpty,
  secao: "os Motores",
};

interface UseEmbarcacaoMotoresResult extends EmbarcacaoMotoresState {
  reload: () => void;
}

/**
 * Consulta os Motores da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoMotores(id: string): UseEmbarcacaoMotoresResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, MOTORES_QUERY);

  return { ...state, motores: data };
}
